import TvanHandleApi from 'api/TvanHandleApi'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import ToastHelper from 'general/helpers/ToastHelper'
import { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import { Typography } from 'antd'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import * as Yup from 'yup'
import { REGEX_TVAN_MESSAGE } from 'general/constants/AppRegex'
import CustomLabel from 'general/components/CustomLabel'
const ModalActiveConnectConsumer = ({
  modalsState,
  setModalsState,
  refetchList,
}) => {
  const [dataConfix, setDataConfix] = useState({
    configNullNameGood: modalsState?.value?.companyConfig?.configNullNameGood,
    companyId: modalsState?.value?.companyId,
  })

  useEffect(() => {
    if (modalsState?.show) {
      setDataConfix({
        configNullNameGood:
          modalsState?.value?.companyConfig?.configNullNameGood,
        companyId: modalsState?.value?.companyId,
      })
    }
  }, [modalsState?.show])

  const connect = async ({ partnerId }) => {
    // Your logic to move to send invoice goes here
    // For example, you can call an API endpoint to move to send invoice
    // await sendInvoiceToHandler(payload)
    try {
      const { success, message } = await TvanHandleApi.connectConsumerPartner({
        partnerId,
      })
      if (success == true) {
        ToastHelper.showSuccess(message)
        refetchList()
      } else {
        ToastHelper.error(message ?? 'Lỗi nội bộ máy chủ')
      }
    } catch (error) {
      console.error('connect function: ' + error)
    }
  }
  console.log('modalsState', modalsState)

  const updateMessageForm = useFormik({
    initialValues: {
      messageId: '',
    },
    validationSchema: Yup.object({
      messageId: Yup.string()
        .matches(REGEX_TVAN_MESSAGE, 'Mã thông điệp không hợp lệ, hãy thử lại!')
        .required('Mã thông điệp không được để trống'),
    }),
    onSubmit: async (values) => {
      // await updateMessage({
      //   invoiceId: tvanState.activeRow?.invoiceId,
      //   messageId: values.messageId.trim(),
      // })
    },
  })
  const thisModalRef = useRef()

  return (
    <>
      <ModalConfirm
        header="Cho phép kết nối consumer"
        content={
          <>
            <p>
              Cho phép kết nối consumer đối tác{' '}
              {modalsState?.value?.namePartner}/
              {modalsState?.value?.userNameRabbitmq}
            </p>
            <div className="w-100"></div>
            <strong>Bạn vẫn muốn thực hiện?</strong>
          </>
        }
        show={modalsState.show}
        setShow={(status) => setModalsState({ ...modalsState, show: status })}
        handleConfirm={(e) => {
          connect({ partnerId: modalsState?.value?.partnerId })
          // e.preventDefault()
          // moveToSendErrorHandler({ invoiceId: tvanState.activeRow?.invoiceId })
          // setModalsState({ key: 'moveStatusModal', value: false })
        }}
      />
    </>
  )
}
export default memo(ModalActiveConnectConsumer)
